import type { ReactNode } from 'react';
import { Fragment } from 'react';

import { cn } from '@/ui/utils/classnames';

export interface StandaloneFrameProps {
  children: ReactNode;
}

function StandaloneFrame({ children }: StandaloneFrameProps) {
  return (
    <div className="size-full sm:flex sm:items-center sm:justify-center sm:bg-gray-100 sm:theme-dark:bg-[#000]">
      <div
        className={cn(
          'box-content size-full sm:h-[672px] sm:w-[400px] sm:overflow-hidden sm:rounded-[32px]',
          'sm:border-2 sm:border-black/6 sm:theme-dark:border-neutral-700',
        )}
      >
        {children}
      </div>
    </div>
  );
}

const Frame = __STANDALONE_MODE__ ? StandaloneFrame : Fragment;

export default Frame;
